import * as React from 'react';
import { Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { ButtonObject, SearchDateTerms } from 'types/common/searchfilter';
import { searchDateTermsLabel } from 'constants/common/searchfilter';
import SubscriptionRangePicker from 'components/backorder/table/subscription/SubscriptionRangePicker';
import {
  getRangePickerMappingDates,
  subscriptionTerms,
} from 'constants/backorder/rangePickerMapperDates';
import { initialSubscriptionTerm } from 'components/backorder/BackOrderSubscribe';

interface Props {
  disabled: boolean;
  subscriptionTerm: [string, string];
  setSubscriptionTerm: Dispatch<SetStateAction<[string, string]>>;
}

const OfferSubscriptionTerm = ({
  disabled,
  subscriptionTerm,
  setSubscriptionTerm,
}: Props): ReactElement => {
  const [startDate] = subscriptionTerm;
  const [selectedShortcut, setSelectedShortcut] = useState<SearchDateTerms | null>(null);

  const shortcutButtons: ButtonObject[] = [
    {
      name: searchDateTermsLabel[SearchDateTerms['1_MONTH']],
      onClick: () => {
        const to = getRangePickerMappingDates({
          startDate,
          subscriptionTerms: subscriptionTerms[SearchDateTerms['1_MONTH']],
        });
        setSubscriptionTerm([startDate, to]);
        setSelectedShortcut(SearchDateTerms['1_MONTH']);
      },
      disabled,
      selected: selectedShortcut === SearchDateTerms['1_MONTH'],
    },
    {
      name: searchDateTermsLabel[SearchDateTerms['3_MONTHS']],
      onClick: () => {
        const to = getRangePickerMappingDates({
          startDate,
          subscriptionTerms: subscriptionTerms[SearchDateTerms['3_MONTHS']],
        });
        setSubscriptionTerm([startDate, to]);
        setSelectedShortcut(SearchDateTerms['3_MONTHS']);
      },
      disabled,
      selected: selectedShortcut === SearchDateTerms['3_MONTHS'],
    },
    {
      name: searchDateTermsLabel[SearchDateTerms['1_YEAR']],
      onClick: () => {
        const to = getRangePickerMappingDates({
          startDate,
          subscriptionTerms: subscriptionTerms[SearchDateTerms['1_YEAR']],
        });
        setSubscriptionTerm([startDate, to]);
        setSelectedShortcut(SearchDateTerms['1_YEAR']);
      },
      disabled,
      selected: selectedShortcut === SearchDateTerms['1_YEAR'],
    },
    {
      name: searchDateTermsLabel[SearchDateTerms['UNTIL_2099']],
      onClick: () => {
        setSubscriptionTerm([startDate, '2099-12-31']);
        setSelectedShortcut(SearchDateTerms['UNTIL_2099']);
      },
      disabled,
      selected: selectedShortcut === SearchDateTerms['UNTIL_2099'],
    },
  ];
  return (
    <SubscriptionRangePicker
      dateInterval={subscriptionTerm}
      setDateInterval={setSubscriptionTerm}
      disableOnFrom={disabled}
      disableOnTo={disabled}
      fromMinDate={initialSubscriptionTerm[0]}
      toMinDate={initialSubscriptionTerm[0]}
      shortcutButtons={shortcutButtons}
      selectedShortcut={selectedShortcut}
      setSelectedShortcut={setSelectedShortcut}
    />
  );
};

export default OfferSubscriptionTerm;
